import { freddyTheme, Grid, SxProps } from '@coolblue-development/freddy';
import { pageTemplateColumns } from '@styles/gridTemplates';

export const PageGridLayout = ({
  color = 'secondary',
  sx,
  children
}: {
  color?: keyof typeof freddyTheme.color.background;
  sx?: SxProps;
  children: React.ReactNode;
}) => {
  return (
    <Grid
      component='main'
      templateColumns={pageTemplateColumns}
      sx={{
        backgroundColor: freddyTheme.color.background[color],
        '> *': {
          padding: '3.2rem 0',
          [freddyTheme.breakpoint.maxWidth('md')]: { padding: '2.4rem 0' }
        },
        '> :nth-of-type(1)': { paddingBottom: '0' },
        '+ footer': {
          backgroundColor: freddyTheme.color.background[color]
        },
        [freddyTheme.breakpoint.minWidth('md')]: { '> :nth-of-type(3)': { paddingTop: '2rem' } },
        ...sx
      }}
    >
      {children}
    </Grid>
  );
};
